import type { FormEvent } from "react";
import { memo, useState } from "react";
import "Components/Auth/RegisterPage/RegisterPage.less";
import { Button, ButtonTypes, IconSize, Input } from "@clintonelec/react-storybook";
import type { RegisterUserPayload } from "Interfaces";
import { useAppDispatch } from "Data/Redux/Store";
import { registerUserAction } from "Data/Redux/Slices/User";
import type { SerializedError } from "@reduxjs/toolkit";
import { notifyError } from "src/Notifications";
import { useNavigate } from "react-router-dom";
import AuthPage from "Components/Auth/AuthPage";

type RegisterFormFields = {
	email: HTMLInputElement;
	username: HTMLInputElement;
	macAddress: HTMLInputElement;
	password: HTMLInputElement;
	confirmPassword: HTMLInputElement;
} & HTMLFormElement;

const RegisterPage = () => {
	const dispatch = useAppDispatch();
	const navigate = useNavigate();
	const [ submitted, setSubmitted ] = useState(false);
	const registerUser = (payload: RegisterUserPayload) => dispatch(registerUserAction(payload));
	const handleNavigateLoginClick = () => navigate("/login");

	const handleRegisterSubmit = (event: FormEvent<RegisterFormFields>) => {
		event.preventDefault();
		setSubmitted(true);

		if (event.currentTarget.checkValidity()) {
			const { email, username, password, confirmPassword, macAddress } = event.currentTarget;
			const registerPayload: RegisterUserPayload = {
				email: email.value,
				macAddress: macAddress.value,
				name: username.value,
				password: password.value,
				passwordConfirmation: confirmPassword.value
			};

			registerUser(registerPayload)
				.unwrap()
				.then(() => {
					handleNavigateLoginClick();
				})
				.catch((error: SerializedError) => {
					if (error) {
						notifyError(error);
					}
				});
		}
	};

	const registerForm = (
		<div className="register-page">
			<div className="logo" />
			<form onSubmit={ handleRegisterSubmit } noValidate>
				<label>Email</label>
				<Input
					name="email"
					wrapClassName="register-input"
					required
					noValidate={ !submitted }
					validityMessage="Email is required"
				/>
				<label>Name</label>
				<Input
					name="username"
					wrapClassName="register-input"
					required
					noValidate={ !submitted }
					validityMessage="Email is required"
				/>
				<label>MAC Address</label>
				<Input
					name="macAddress"
					wrapClassName="register-input"
					required
					noValidate={ !submitted }
					validityMessage="A MAC Address is required."
				/>
				<label>Password</label>
				<Input
					name="password"
					wrapClassName="register-input"
					password
					required
					noValidate={ !submitted }
					validityMessage="Password is required"
				/>
				<label>Confirm Password</label>
				<Input
					name="confirmPassword"
					wrapClassName="register-input"
					password
					required
					noValidate={ !submitted }
					validityMessage="Confirm password is required"
				/>
				<Button
					id="register-button"
					className="register-button"
					type={ ButtonTypes.PRIMARY }
					htmlType="submit"
					icon={ {
						name: "sign-in",
						size: IconSize.SMALLER
					} }
				>
					Register
				</Button>
			</form>
			<div className="navigate-login" onClick={ handleNavigateLoginClick }>Return to Log in page</div>
		</div>
	);

	return <AuthPage form={ registerForm } />;
};

export default memo(RegisterPage);
